import {
  GET_SINGLE_NEWS_LOADING,
  GET_SINGLE_NEWS_SUCCESS,
  GET_SINGLE_NEWS_FAILURE,
} from "redux/types";

const initialState = {
  singleNewsLoading: false,
  singleNews: null,
  errors: null,
};

export const singleNewsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_SINGLE_NEWS_LOADING:
      return { ...state, singleNewsLoading: action.payload };
    case GET_SINGLE_NEWS_SUCCESS:
      return { ...state, singleNews: action.payload };
    case GET_SINGLE_NEWS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
